import { gql } from 'graphql-request'

import graphQLRequest from '@/CandidateExperience/config/graphQLRequest'

const FETCH_POSITION_PREVIEW = gql`
  query positionPreview($positionId: ID!, $candidateProfileId: ID!) {
    position(id: $positionId) {
      name
      roleExperience {
        role {
          name
        }
        yearsExperience
      }
      otherRoles {
        id
        name
      }
      mustHaveSkillExperiences {
        id
        skill {
          name
        }
        yearsExperience
      }
      niceToHaveSkills {
        id
        name
      }
      languages {
        name
        iso6391Code
      }
      workplacePolicy {
        type
        comprehensiveLocations {
          displayAddress
        }
      }
      otherLocations {
        displayAddress
      }
      requiresWorkAuthorisation
      workAuthorisation {
        statuses
        countries {
          name
          iso2Code
        }
      }
      visaSponsorshipAvailable
      employmentType
      contractDuration
      publishedSalaryRange {
        start
        end
      }
      currency {
        code
      }
      remunerationPeriod
      company {
        name
        logoSmallUrl
        brandColor
        slug
        published
      }
      description
      application(candidateProfileId: $candidateProfileId) {
        status
        interviewRequest {
          id
        }
      }
    }
  }
`

export const getPositionPreview = ({ positionId, candidateProfileId }) => {
  return graphQLRequest(FETCH_POSITION_PREVIEW, { positionId, candidateProfileId })
}

export const CREATE_APPLICATION = gql`
  mutation createApplication($input: CreateApplicationInput!) {
    createApplication(input: $input) {
      application {
        id
        status
      }
    }
  }
`

export const createApplication = ({ positionId, candidateProfileId }) => {
  return graphQLRequest(CREATE_APPLICATION, { input: { positionId, candidateProfileId } })
}
